'use strict';

const couponCardTemplate = require('../../coupons/coupon_card.html.mustache');

const CouponCard = require('../../coupons/frontend/coupon_card');

const dealCardTemplate = require('../../deals/deal_card.html.mustache');

class MultipleOffers {
  constructor({
    el,
    placeId,
    isUsingOfferAggregator,
    totalDeals,
    totalCoupons,
    limit,
    initialCouponLimit,
    brandId,
  }) {
    this.doShowMore = this.doShowMore.bind(this);
    this.el = el;
    this.placeId = placeId;
    this.brandId = brandId;
    this.isUsingOfferAggregator = isUsingOfferAggregator;
    this.totalDeals = totalDeals;
    this.totalCoupons = totalCoupons;
    this.limit = limit;
    this.initialCouponLimit = initialCouponLimit;
    this.$el = $(this.el);
    this.rootUrl = '/merchant-page';
    this.offerSelector = '.offer';
    this.$deals = this.$el.find('.offer-cards-deal');
    this.$coupons = this.$el.find('.offer-cards-coupon');
    this.$showMore = this.$el.find('.show-more-button');
    this.$showMoreText = this.$showMore.find('.show-more-text');
    this.$showMoreLoader = this.$showMore.find('.show-more-loader');
    this.activeShowMoreClass = 'active';
    this.offerProfiles = [
      {
        dataKey: 'deals',
        template: dealCardTemplate,
        container: this.$deals,
        offerCardClass: null,
      },
      {
        dataKey: 'coupons',
        template: couponCardTemplate,
        container: this.$coupons,
        offerCardClass: CouponCard,
      },
    ];
    this.init();
    this.bindEventHandlers();
  }

  init() {
    // Initially, hide all offers except the first @limit.
    const hiddenStartingIndex = this.limit - 1;
    this.$el.find(`${this.offerSelector}:gt(${hiddenStartingIndex})`).hide(); // If there are more than @initialCouponLimit coupons displayed at
    // the initial page load, we need to hide the rest except the first
    // @initialCouponLimit coupons. This is based on a policy we need to
    // comply with so Google will not penalize Coupons team for potential
    // duplicate content.

    const $visibleCoupons = this.$coupons.find(`${this.offerSelector}:visible`);

    if ($visibleCoupons.size() > this.initialCouponLimit) {
      $visibleCoupons.slice(this.initialCouponLimit).hide();
    }
  }

  bindEventHandlers() {
    return this.$showMore.click(this.doShowMore);
  }

  doShowMore() {
    if (this.$showMore.hasClass(this.activeShowMoreClass)) {
      return;
    }

    this.showLoader();

    if (this.isUsingOfferAggregator) {
      const cb = () => {
        this.uncoverNextBatch();
        this.controlShowMoreVisibility();
        this.hideLoader();
        this.truncateText();
      };

      if (this.isOfferLoadableViaOfferAggregator()) {
        this.fetchOffers(cb);
      } else {
        cb();
      }
    } else {
      this.hideShowMore();
      this.uncoverAll();
    }
  }

  truncateText() {
    window.GIG.Utils.truncateElements($('#multiple-offers'));
  }

  fetchOffers(cb) {
    const data = {};
    const offerTypes = [];

    for (const offerType of ['deal', 'coupon']) {
      if (this.isOfferLoadableViaOfferAggregator(offerType)) {
        // The offset for each type is equal to the total number of offers
        // for that type that have been loaded. For example if you have 20
        // deals loaded already, the next OA call you will have offset=20.
        data[`${offerType}_offset`] = this.getTotalOffersLoaded(offerType);
        data[`${offerType}_limit`] = this.limit;
        offerTypes.push(offerType);
      }
    }

    if (!(offerTypes.length > 0)) {
      cb();
      return;
    }

    data.types = offerTypes.join(',');
    $.ajax({
      url: `${this.rootUrl}/multiple-offers/fetch?place_id=${this.placeId}&brand_id=${this.brandId}`,
      method: 'GET',
      data,
      contentType: 'application/json',
      success: res => {
        if (res.data == null || res.result !== 'ok') {
          return;
        }

        this.appendOffers(res.data);
      },

      complete() {
        cb();
      },
    });
  }

  appendOffers(offerData) {
    if (offerData == null) {
      return;
    }

    (() => {
      const result = [];

      for (const offerProfile of this.offerProfiles) {
        if (
          offerData[offerProfile.dataKey] &&
          offerData[offerProfile.dataKey].list &&
          offerData[offerProfile.dataKey].list.length > 0
        ) {
          result.push(
            (() => {
              const result1 = [];

              for (const row of offerData[offerProfile.dataKey].list) {
                row.translate = row.t = () => text =>
                  window.I18n.translate(text);

                const $row = $(offerProfile.template.render(row));

                if (offerProfile.offerCardClass != null) {
                  new offerProfile.offerCardClass($row);
                }

                result1.push(offerProfile.container.append($row.hide()));
              }

              return result1;
            })()
          );
        } else {
          result.push(undefined);
        }
      }

      return result;
    })();
  }

  getOfferCards(hiddenOnly, first, type) {
    const containerDecorator = type != null ? `.offer-cards-${type} ` : '';
    const visibilityDecorator = hiddenOnly ? ':hidden' : '';
    const counterDecorator = first > 0 ? `:lt(${first})` : '';
    return this.$el.find(
      `${containerDecorator}${this.offerSelector}${visibilityDecorator}${counterDecorator}`
    );
  }

  getTotalOffers(type) {
    switch (type) {
      case 'deal':
        return this.totalDeals;

      case 'coupon':
        return this.totalCoupons;

      default:
        return this.totalDeals + this.totalCoupons;
    }
  }

  getTotalOffersLoaded(type) {
    return this.getOfferCards(false, 0, type).size();
  }

  getTotalOffersHidden(type) {
    return this.getOfferCards(true, 0, type).size();
  }

  isOfferLoadableViaOfferAggregator(type) {
    return this.getTotalOffers(type) > this.getTotalOffersLoaded(type);
  }

  isOfferUncoverable() {
    return this.getTotalOffersHidden() > 0;
  }

  showLoader() {
    this.$showMore.addClass(this.activeShowMoreClass);
    this.$showMoreText.hide();
    return this.$showMoreLoader.show();
  }

  hideLoader() {
    this.$showMoreLoader.hide();
    this.$showMoreText.show();
    return this.$showMore.removeClass(this.activeShowMoreClass);
  }

  hideShowMore() {
    this.hideLoader();
    return this.$showMore.hide();
  }

  controlShowMoreVisibility() {
    if (
      !this.isOfferLoadableViaOfferAggregator() &&
      !this.isOfferUncoverable()
    ) {
      this.hideShowMore();
    }
  }

  showOfferCards(offerCards) {
    return offerCards.slideDown('fast');
  }

  uncoverNextBatch() {
    return this.showOfferCards(this.getOfferCards(true, this.limit));
  }

  uncoverAll() {
    return this.showOfferCards(this.getOfferCards(true, 0));
  }
}

$(() => {
  const el = '#multiple-offers';
  const $el = $(el);
  const placeId = $el.data('place-id');
  const brandId = $el.data('brand-id');
  const isUsingOfferAggregator = Boolean($el.data('offer-aggregator-enabled'));
  const totalDeals = parseInt($el.data('total-deals'));
  const totalCoupons = parseInt($el.data('total-coupons'));
  const limit = parseInt($el.data('offer-aggregator-limit'));
  const initialCouponLimit = parseInt($el.data('initial-coupon-limit'));
  return new MultipleOffers({
    el,
    placeId,
    isUsingOfferAggregator,
    totalDeals,
    totalCoupons,
    limit,
    initialCouponLimit,
    brandId,
  });
});
